export default __webpack_public_path__ + "static/media/img-2.f7d91a50.svg";